export default {
  premiumBeatDataOnly:
    'This data represents sales on PremiumBeat. These reports are updated once daily at 9:00 AM UTC and may be subject to adjustment, such as those resulting from additional sales and refunds',
};
